/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReceiptFieldResponse } from './ReceiptFieldResponse';
import {
    ReceiptFieldResponseFromJSON,
    ReceiptFieldResponseFromJSONTyped,
    ReceiptFieldResponseToJSON,
    ReceiptFieldResponseToJSONTyped,
} from './ReceiptFieldResponse';

/**
 * 
 * @export
 * @interface ReceiptResponse
 */
export interface ReceiptResponse {
    /**
     * 
     * @type {{ [key: string]: ReceiptFieldResponse; }}
     * @memberof ReceiptResponse
     */
    fields?: { [key: string]: ReceiptFieldResponse; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ReceiptResponse
     */
    receipt?: Array<string> | null;
}

/**
 * Check if a given object implements the ReceiptResponse interface.
 */
export function instanceOfReceiptResponse(value: object): value is ReceiptResponse {
    return true;
}

export function ReceiptResponseFromJSON(json: any): ReceiptResponse {
    return ReceiptResponseFromJSONTyped(json, false);
}

export function ReceiptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fields': json['fields'] == null ? undefined : (mapValues(json['fields'], ReceiptFieldResponseFromJSON)),
        'receipt': json['receipt'] === undefined ? undefined : json['receipt'] === null ? null : json['receipt'],
    };
}

export function ReceiptResponseToJSON(json: any): ReceiptResponse {
    return ReceiptResponseToJSONTyped(json, false);
}

export function ReceiptResponseToJSONTyped(value?: ReceiptResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fields': value['fields'] == null ? undefined : (mapValues(value['fields'], ReceiptFieldResponseToJSON)),
        'receipt': value['receipt'],
    };
}

